var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeneca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.6 173.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#da291c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m.27,125.03h17.69c10.67,0,17.69,5.67,17.69,14.99v.14c0,10.19-8.51,15.46-18.56,15.46H5.6v16.67H.27v-47.25Zm17.01,25.72c7.83,0,12.96-4.19,12.96-10.4v-.13c0-6.75-5.06-10.26-12.69-10.26H5.6v20.79h11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m40.56,148.8v-.14c0-13.03,9.79-24.44,24.17-24.44s24.03,11.27,24.03,24.3v.13c0,13.03-9.79,24.44-24.17,24.44s-24.03-11.27-24.03-24.3Zm42.66,0v-.14c0-10.73-7.83-19.51-18.63-19.51s-18.5,8.64-18.5,19.37v.13c0,10.73,7.83,19.51,18.63,19.51s18.5-8.64,18.5-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m97.33,125.03h5.33v42.33h26.6v4.93h-31.93v-47.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m142.42,153.59l-19.64-28.55h6.48l15.93,23.63,16.07-23.63h6.21l-19.64,28.49v18.77h-5.4v-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m185.75,129.96h-15.86v-4.93h37.13v4.93h-15.86v42.33h-5.4v-42.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m214.3,125.03h34.16v4.86h-28.83v16.13h25.79v4.86h-25.79v16.54h29.16v4.86h-34.5v-47.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m254.73,148.8v-.14c0-13.37,9.99-24.44,23.9-24.44,8.57,0,13.7,3.04,18.43,7.49l-3.65,3.92c-3.98-3.78-8.44-6.48-14.85-6.48-10.46,0-18.29,8.51-18.29,19.37v.13c0,10.94,7.9,19.51,18.29,19.51,6.48,0,10.73-2.5,15.26-6.82l3.51,3.44c-4.93,5-10.33,8.3-18.9,8.3-13.64,0-23.69-10.73-23.69-24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m303.94,125.03h5.33v20.99h27.27v-20.99h5.33v47.25h-5.33v-21.26h-27.27v21.26h-5.33v-47.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m352.54,125.03h5l29.77,37.87v-37.87h5.2v47.25h-4.25l-30.51-38.75v38.75h-5.2v-47.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m403.63,125.03h5.33v47.25h-5.33v-47.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m418.01,148.8v-.14c0-13.37,9.99-24.44,23.9-24.44,8.57,0,13.7,3.04,18.43,7.49l-3.65,3.92c-3.98-3.78-8.44-6.48-14.85-6.48-10.46,0-18.29,8.51-18.29,19.37v.13c0,10.94,7.9,19.51,18.29,19.51,6.48,0,10.73-2.5,15.26-6.82l3.51,3.44c-4.93,5-10.33,8.3-18.9,8.3-13.64,0-23.69-10.73-23.69-24.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m30.85,85.71c9.14,0,14.71-4.71,14.71-10.72,0-9.14-10-11.71-23.56-18.71C8.57,49.42,1.57,39.57,1.57,28.14,1.57,11.72,14.84,0,37.13,0c8.28,0,16,1.57,24.28,4.57v16.28c-8.14-4.14-14.72-6.56-20.14-6.56-7.72,0-12.71,4.28-12.71,9.43,0,8,10.29,10.86,26.99,20,11.14,6.14,16.29,14.57,16.29,26.28,0,18.14-15,30.72-38.13,30.72-9.57,0-18.87-1.86-28.72-5.15L0,74.99c11.28,6.86,20.84,10.72,30.85,10.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m104.37,64.42c0,.87-.14,1.75-.14,2.48,0,12.52,8.16,19.82,21.42,19.82,6.56,0,14.44-2.76,24.34-7.43l-5.24,16.9c-8.6,2.92-16.76,4.96-25.95,4.96-26.09,0-41.39-14.72-41.39-36.59s16.04-37.32,37.9-37.32c19.39,0,33.81,13.7,33.81,35.28v1.89h-44.75Zm10.21-23.62c-5.69,0-9.33,3.79-9.63,10.79h18.66c0-7.14-3.21-10.79-9.03-10.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m158.17,86.13v-43.14c0-5.69-1.17-9.62-4.96-13.12h6.71c7.58,0,15.3-.28,23.32-1.6l.58,7.15c5.83-4.67,11.37-7,17.93-7,15.31,0,25.22,9.77,25.22,25.66v32.07c0,5.68,1.17,9.47,4.96,12.97h-35.56c3.79-3.5,4.95-7.29,4.95-12.97v-22.3c0-13.56-1.75-20.7-9.19-20.7s-8.31,7.14-8.31,20.7v22.3c0,5.68,1.17,9.47,4.95,12.97h-35.56c3.79-3.5,4.96-7.29,4.96-12.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m261.86,64.42c0,.87-.14,1.75-.14,2.48,0,12.52,8.16,19.82,21.42,19.82,6.56,0,14.44-2.76,24.34-7.43l-5.24,16.9c-8.61,2.92-16.77,4.96-25.95,4.96-26.09,0-41.39-14.72-41.39-36.59s16.04-37.32,37.9-37.32c19.39,0,33.81,13.7,33.81,35.28v1.89h-44.75Zm10.21-23.62c-5.69,0-9.33,3.79-9.63,10.79h18.66c0-7.14-3.2-10.79-9.03-10.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m376.84,96.34c-7.58,3.35-15.02,4.81-22.89,4.81-24.35,0-39.8-15.45-39.8-36,0-21.72,16.47-37.75,42.28-37.75,4.08,0,9.47.58,16.33,1.6v17.35c-5.84-3.06-10.49-4.67-14.28-4.67-9.62,0-15.89,7.29-15.89,19.98,0,15.01,7.44,24.19,19.68,24.19,5.83,0,12.24-2.04,19.82-6.13l-5.24,16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m409.44,78.55c0,5.11,3.64,8.61,10.06,8.61h1.16l-6.12,12.97c-4.09.29-6.86.44-8.61.44-14.43,0-24.19-9.33-24.19-21.72,0-10.78,6.85-17.63,20.26-20.84,12.82-3.06,21.14-2.77,21.14-9.76,0-4.38-3.06-6.71-9.19-6.71s-11.95,1.45-18.51,4.08l6.84-15.6c5.55-1.6,10.79-2.62,16.33-2.62,11.37,0,19.53,2.33,24.78,7.73,6.12,6.27,6.27,14.14,6.27,24.19v17.49c0,7.58,2.62,9.77,10.93,10.94l-5.53,12.24c-3.79.29-6.41.44-8.16.44-13.99,0-23.91-8.61-23.91-21.58v-12.24c-9.04,3.49-13.56,6.12-13.56,11.95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeneca);
export default __webpack_public_path__ + "static/media/SENECA.1caab349715a75cd1abeb5baed05d46e.svg";
export { ForwardRef as ReactComponent };